// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_password-module--container--1pVxY","button":"switch_password-module--button--EWzhs"};